import React from "react";
import { Image } from "semantic-ui-react";
import "../styles/error-page.scss";
import "../styles/main.scss";
import NoMaterialsOnSite from "../assets/no-materials-on-site.png";
import { ErrorPages } from "./constants/GlobalConstants";
import LmsMessage from "./lms/ui/LmsMessage";

const BCError = ({ isGreaterThanTablet, isSidebar, errorPage = ErrorPages.NO_MATERIAL_ON_SITE }) => {
  return (
    <div className={(isGreaterThanTablet && isSidebar) ? "hide-sidebar" : "sidebar"}>
      {errorPage === ErrorPages.SCREEN_SIZE_NOT_SUPPORTED ? <LmsMessage
        header="Oops! It looks like something went wrong."
        text="Tablet screen sizes and smaller are not supported. Please increase your window size and try again."
        skipAutoClose={true}
        skipDismiss
      /> :
      <div className="error-body">
        <Image src={NoMaterialsOnSite} size='big' />
      </div>}
    </div>
  );
};

export default BCError;